export const LaunchPriority = {
	LOW: 1,
	NORMAL: 2,
	HIGH: 3,
	CRITICAL: 4,
};
